(() => {
  function init(root=document) {
    root.querySelectorAll('[data-lb-fullscreen]:not([data-bound])').forEach(button => {
      const hero=button.closest('.lb-hero'), panel=hero.querySelector('[data-lb-fixture-panel]');
      const close=hero.querySelector('[data-lb-fullscreen-close]'),label=button.querySelector('span');
      button.dataset.bound='true';button.hidden=false;
      let open=false,inertSiblings=[];
      function isolate(next){
        if(next){let child=hero;while(child.parentElement&&child!==document.body){for(const sibling of child.parentElement.children){if(sibling!==child&&!sibling.inert){sibling.inert=true;inertSiblings.push(sibling);}}child=child.parentElement;}
          hero.setAttribute('role','dialog');hero.setAttribute('aria-modal','true');hero.setAttribute('aria-label',button.dataset.enter);
        }else{inertSiblings.forEach(el=>el.inert=false);inertSiblings=[];hero.removeAttribute('role');hero.removeAttribute('aria-modal');hero.removeAttribute('aria-label');}
      }
      function setOpen(next){
        hero.dispatchEvent(new Event('lb:framing-start'));
        open=next;isolate(open);hero.classList.toggle('lb-is-fullscreen',open);
        document.documentElement.classList.toggle('lb-immersive-open',open);
        close.hidden=!open;label.textContent=button.dataset[open?'exit':'enter'];
        button.setAttribute('aria-pressed',String(open));
        requestAnimationFrame(()=>hero.dispatchEvent(new Event('lb:framing-resize')));
        (open?close:button).focus({preventScroll:true});
      }
      matchMedia('(min-width:1100px) and (hover:hover) and (pointer:fine)').addEventListener('change',event=>{if(!event.matches&&open)setOpen(false);});
      button.addEventListener('click',()=>setOpen(!open));
      close.addEventListener('click',()=>setOpen(false));

      document.addEventListener('keydown',event=>{if(!open)return;if(event.key==='Escape'){event.preventDefault();setOpen(false);}else if(event.key==='Tab'){
        const items=Array.from(hero.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')).filter(el=>!el.disabled&&!el.hidden&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
        const first=items[0],last=items.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }});
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(hero)&&open){document.documentElement.classList.remove('lb-immersive-open');isolate(false);}});
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
